import styled from 'styled-components';

export const Img = styled.img`
  width: 100%;
  display: block;
  margin-bottom: 30px;
`;

export const Date = styled.p`
  font-size: 14px;
`;

export const Author = styled.p`
  font-size: 14px;
`;

export const Container = styled.div`
  margin-bottom: 50px;
`;
